module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1) ? _c('alllist', {
    ref: "alllist",
    attrs: {
      "get-status": _vm.alllist
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4ee5a6b5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ee5a6b5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/community/activity/index.vue
// module id = 2701
// module chunks = 0